<template>
  <div
    class="select-box"
    :class="{ checked: modelValue === 'true' }"
    @click="updateValue"
    @keyup.enter="updateValue"
    :tabindex="0"
  >
    <img
      class="checkmark"
      src="@/assets/icons/Svgs/Pfad_6935.svg"
      alt=""
    />
    <div class="icon">
      <img
        class="default"
        :src="iconDefault"
        alt=""
      />
      <img
        class="hover"
        :src="iconHover"
        alt=""
      />
    </div>
    <div
      class="text mt-3"
      v-html="text"
    />
  </div>
</template>
<script>
export default {
  name: "select-box",
  props: {
    iconDefault: String,
    iconHover: String,
    text: String,
    modelValue: String,
  },
  methods: {
    updateValue() {
      switch (this.modelValue) {
        case "true":
          this.$emit("update:modelValue", "false");
          break;
        case "false":
          this.$emit("update:modelValue", "true");
          break;
      }
    },
  },
};
</script>
